define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/location.js
// module id = a1Jc
// module chunks = 11